// config.js
const config = {
    // apiUrl: 'http://172.20.10.3:3001',
    apiUrl: 'https://n77.kz:3001',
    
    nameCargo: 'N77',
    vapidPublicKey: 'BJtBjK8np_BeUhsJubD6JLvmmGSDGPWlbOC_wqrY6Y7Qnsv4NorYvAAdV3-so5slfk1aru_j9MehVv3ggqmAm90'
  };
  
  
export default config;
